/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 98.56 86.67',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" d="M48.91 4.72a.43.43 0 01.15-.17.48.48 0 01.22 0 .45.45 0 01.22 0 .44.44 0 01.16.17L94 81.52a.38.38 0 01.06.22.48.48 0 01-.06.26.44.44 0 01-.16.17.44.44 0 01-.22 0H4.94a.47.47 0 01-.22 0 .53.53 0 01-.16-.17.42.42 0 010-.43z" _fill="none" _stroke="#e25046" stroke-width="9"/><path pid="1" d="M47.64 58.67l-1.7-17.34v-8H53v8l-1.65 17.34zm-1.42 8.81v-6.55h6.55v6.55z" _fill="#e25046"/></g></g>'
  }
})
